export const cityAliases = new Set([
  'almaty',
  'astana',
  'karaganda',
  'kokshetau',
  'shymkent',
  'petropavlovsk',
  'ust-kamenogorsk',
  'atirau',
  'kostanay',
  'uralsk',
  'taraz',
  'semey',
  'taldykorgan',
  'aktobe',
  'kyzylorda',
  'aktau',
  'akkol',
  'akmol',
  'aksu',
  'aksuat',
  'aksukent',
  'aral',
  'arkalyk',
  'arys',
  'astrakhanka',
  'atbasar',
  'baykonur',
  'balkashino',
  'balpyk-bi',
  'balkhash',
  'bautino',
  'beyneu',
  'borovskoy',
  'burabai',
  'derzhavinsk',
  'dzhusaly',
  'dossor',
  'egindykol',
  'yereimentau',
  'esik',
  'esil',
  'zhaksy',
  'zhanakorgan',
  'zhanaozen',
  'zhanatas',
  'zhansugurov',
  'zharkent',
  'jezkazgan',
  'zhezkent',
  'zhetybay',
  'zhetysay',
  'zaysan',
  'zerenda',
  'kazalinsk',
  'kazygurt',
  'karabulak',
  'karatau',
  'cargaly',
  'kaskelen',
  'kentau',
  'kapchagay',
  'korgalzhyn',
  'korday',
  'kulsary',
  'kurchumskiy-raion',
  'kuryk',
  'kushmurun',
  'lenger',
  'lisakovsk',
  'maykain',
  'makinsk',
  'merke',
  'moyinkum',
  'otegen-batyr',
  'pavlodar',
  'ridder-leninogorsk',
  'rudniy',
  'сарань',
  'saryagash',
  'sarykemer',
  'saryozek',
  'satpaev-nikolskiy',
  'selo-tuimebayeva',
  'serebryansk',
  'smirnovo',
  'stepnogorsk',
  'stepnyak',
  'taiynsha',
  'talgar',
  'tekeli',
  'temirtau',
  'tobol',
  'turara-ryskulova',
  'turkestan',
  'uzynagash',
  'ucharal',
  'ushtobe',
  'khromtau',
  'chundzha',
  'shalkar',
  'shardara',
  'shaulder',
  'shakhtinsk',
  'shieli',
  'sholakkorgan',
  'shu',
  'shchuchinsk',
  'ekibastuz',
]);
